import { AssetSummaryDTO } from '@ketch-com/figurehead'
// TODO:BAC - BE has to provide context on what "primary key" even means.  For now, hard-code to return false so "primary key" is not rendered in the UI
export const getHasPrimaryKey = (asset: AssetSummaryDTO): boolean => {
  // do stuff
  return false
}
